"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportResetEditorlock = exports.reportResetEditorUnlock = exports.reportEditorUnlock = exports.reportEditorSucess = exports.reportEditorReset = exports.reportEditorLockExist = exports.reportEditorLock = exports.reportEditorList = exports.reportEditorError = exports.reportEditorEditRecord = exports.reportEditorEdit = void 0;
var _reportEditor = require("./reportEditor.constant");
// @flow

// common success
var reportEditorSucess = function reportEditorSucess(actionType, data) {
  return {
    type: _reportEditor.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.reportEditorSucess = reportEditorSucess;
var reportEditorError = function reportEditorError(actionType, error) {
  return {
    type: _reportEditor.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * editor edit
 * @param payload
 * @returns api response
 * @description this function used to edit.
 */
exports.reportEditorError = reportEditorError;
var reportEditorEdit = function reportEditorEdit(data) {
  return {
    type: _reportEditor.actionTypes.REPORT_EDIT,
    payload: data
  };
};

/**
 * editor edit
 * @param payload
 * @returns api response
 * @description this function used to edit.
 */
exports.reportEditorEdit = reportEditorEdit;
var reportEditorList = function reportEditorList(data) {
  return {
    type: _reportEditor.actionTypes.LIST,
    payload: data
  };
};

/**
 * editor edit
 * @param payload
 * @returns api response
 * @description this function used to edit.
 */
exports.reportEditorList = reportEditorList;
var reportEditorLockExist = function reportEditorLockExist(data) {
  return {
    type: _reportEditor.actionTypes.EDITORLOCK_EXIST,
    payload: data
  };
};

/**
 * editor edit
 * @param payload
 * @returns api response
 * @description this function used to edit.
 */
exports.reportEditorLockExist = reportEditorLockExist;
var reportEditorLock = function reportEditorLock(data) {
  return {
    type: _reportEditor.actionTypes.EDITORLOCK,
    payload: data
  };
};
exports.reportEditorLock = reportEditorLock;
var reportResetEditorlock = function reportResetEditorlock(data) {
  return {
    type: _reportEditor.actionTypes.RESET_EDITORLOCK,
    payload: data
  };
};

/**
 * editor edit
 * @param payload
 * @returns api response
 * @description this function used to edit.
 */
exports.reportResetEditorlock = reportResetEditorlock;
var reportEditorUnlock = function reportEditorUnlock(data) {
  return {
    type: _reportEditor.actionTypes.EDITORUNLOCK,
    payload: data
  };
};
exports.reportEditorUnlock = reportEditorUnlock;
var reportResetEditorUnlock = function reportResetEditorUnlock(data) {
  return {
    type: _reportEditor.actionTypes.RESET_EDITORUNLOCK,
    payload: data
  };
};

/**
 * edit record
 * @param payload
 * @returns api response
 * @description this function used to edit record.
 */
exports.reportResetEditorUnlock = reportResetEditorUnlock;
var reportEditorEditRecord = function reportEditorEditRecord(payload) {
  return {
    type: _reportEditor.actionTypes.REPORT_EDIT_RECORD,
    payload: payload
  };
};

/**
 * edit record reset
 * @param payload
 * @returns api response
 * @description this function used to edit record reset.
 */
exports.reportEditorEditRecord = reportEditorEditRecord;
var reportEditorReset = function reportEditorReset() {
  return {
    type: _reportEditor.actionTypes.RESET
  };
};
exports.reportEditorReset = reportEditorReset;